import React, {useRef, useState} from "react";
import * as PR from "../../prime-modules/index";
import { Link, useNavigate } from 'react-router-dom';
import Input from "../../components/input";
import { Form, Formik } from "formik";
import "./index.scss";
import Layout from "../../components/layout/Layout";
import { signUpAPI } from "../../services/affiliateApi";
import { useMutation } from "react-query";
import { signUpValidationSchema } from "../../utils/schema";
import { useSelector } from "react-redux";
import { COUNTRY_CODE } from "../../utils/localstore";
import { globalConfig } from "../../constants";

const AffiliateSignup = () => {
    const appName = process.env.REACT_APP_NAME;
    const isCorporate = appName?.includes("corporate");
    const siteUrl = process.env.REACT_APP_PARTNER_URL;
    const { affiliate } = useSelector(state => state.language?.activelang);
    const toast = useRef();
    const formikRef = useRef(null);
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(false);

    const initialValues = {
        firstName: '',
        email: '',
        affiliateName:'',
        phone: '',
        password: '',
        afid:'',
        confirmPassword: '',
        websites: []
    }
    
    const {mutate} = useMutation(signUpAPI,{
        onSuccess:(o)=>{
            toast.current.show({ severity: 'success',life: globalConfig?.toastDisplayTime, summary: 'Success', detail: 'Registered successfully.' });
            formikRef.current.resetForm();
            setTimeout(() => {
                navigate('/affiliate-signin');
              }, 2000);
        },
        onError:(o)=>{
            toast.current.show({ severity: 'error',life:globalConfig?.errorToastDisplayTime, summary: 'Error', detail: o?.message})
        }
    })

    const submitHanlder  = value => {
        const [callingCode, localPhoneNumber] = `+${value?.phone}`?.split('-');
        mutate({ ...value, phone: { callingCode, localPhoneNumber }});
    }

 const termsLink = ['data2go', 'data2go-corporate'].includes(appName)
  ? '/terms-and-conditions'
  : `${siteUrl}/terms-and-conditions`;

    return (
    <>  
        <Layout>
            <PR.Toast ref={toast} />
            <section className="signup-section">
            <div className="grid">
                <div className="col-12 text-center">
                    <h1>{isCorporate ? affiliate?.AFFNL0144 : affiliate?.AFFNL0042}</h1>
                    <p>{isCorporate ? affiliate?.AFFNL0148 : affiliate?.AFFNL0045}<br/>{affiliate?.AFFNL0133}</p>
                    <div className="signup-wrapper">
                        {/* Form section starts here */}
                        <Formik innerRef={formikRef} initialValues={initialValues} validationSchema={signUpValidationSchema} onSubmit={submitHanlder} >
                            <Form autoComplete="off" className="form-block" >
                                <div className='grid'>
                                    <div className="col-12">
                                        <Input id={'firstName'} name={'firstName'} label={affiliate?.AFFNL0001} type={'text'} aria-describedby={'f-name'} placeholder={affiliate?.AFFNL0031} />
                                    </div>
                                    <div className="col-12 md:col-12">
                                        <Input id={'email'} name={'email'} label={affiliate?.AFFNL0006} type={'email'} aria-describedby={'email'} placeholder={affiliate?.AFFNL0032} />
                                    </div>
                                  {!!localStorage.getItem(COUNTRY_CODE) ? <div className="col-12 md:col-12">
                                        <Input id={'phone'} name={'phone'} country={localStorage.getItem(COUNTRY_CODE).toLocaleLowerCase()} label={affiliate?.AFFNL0003} type={'text'} aria-describedby={'email'} placeholder={affiliate?.AFFNL0033} />    
                                    </div>: <div className="col-12 md:col-12">
                                        <Input id={'phone'} name={'phone'} country={'gb'} label={affiliate?.AFFNL0003} type={'text'} aria-describedby={'email'} placeholder={affiliate?.AFFNL0033} />    
                                    </div>}

                                    <div className="col-12">
                                        <Input id={'affiliateName'} name={'affiliateName'} label={affiliate?.AFFNL0140 || "Business/Company name"} type={'text'} aria-describedby={'f-affiliate'} placeholder={affiliate?.AFFNL0141 || "Enter your business/company name"} />
                                    </div>
                                    <div className="col-12 md:col-12 relative">
                                        <Input id={'afid'} name={'afid'} label={affiliate?.AFFNL0129} type={'text'} aria-describedby={'af-id'} placeholder={affiliate?.AFFNL0130} /> 
                                        <div className="afid-span">
                                            <span className="custom-tooltip-btn pi pi-info-circle"></span>
                                            <PR.Tooltip target=".custom-tooltip-btn">
                                                <p>{affiliate?.AFFNL0134}</p>
                                            </PR.Tooltip>
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-12">
                                        <Input id={'websites'} name={'websites'} label={affiliate?.AFFNL0131}  type={'websites'} aria-describedby={'website'}  placeholder={affiliate?.AFFNL0132} />   
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <Input id={'password'} name={'password'} feedback={false} type={'password'}  label={affiliate?.AFFNL0016} aria-describedby={'password'} toggleMask placeholder={affiliate?.AFFNL0040} />    
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <Input id={'confirmPassword'} name={'confirmPassword'} feedback={false} type={'password'} label={affiliate?.AFFNL0002} aria-describedby={'confirm-password'} toggleMask placeholder={affiliate?.AFFNL0041} />    
                                    </div>
                                    <div className="col-12">
                                        <div className="flex align-items-top gap-3 mb-5">
                                            <PR.Checkbox inputId="enableButton" checked={isChecked} onChange={(e) => setIsChecked(e.checked)}></PR.Checkbox>
                                            <label htmlFor="enableButton">{affiliate?.AFFNL0135} <Link target="_blank" to={termsLink}>{isCorporate ? affiliate?.AFFNL0146 : affiliate?.AFFNL0136}</Link></label>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <PR.Button disabled={!isChecked} label={affiliate?.AFFNL0038} type='submit' className="signup-button w-12"/>
                                    </div>
                                </div>
                                <p className="link-p">{affiliate?.AFFNL0019} <Link to="/affiliate-signin">{affiliate?.AFFNL0014}</Link></p>
                            </Form>
                        </Formik>
                        {/* Form section ends here */}
                    </div>
                </div>
            </div>
        </section>
        </Layout>
    </>
  );
};

export default AffiliateSignup;
